import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './test/reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/FontAwsome';
import './assets/css/dash.css';
import { Provider } from "react-redux";
import store from './redux/store/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
